import { useTypesStore } from "../store/Types.js";
import { useTypesRender } from "../utils/useRender.js";
export var Date = props => {
  var {
    Date: Comp = {}
  } = useTypesStore();
  useTypesRender(Comp, props, 'Date');
  return null;
};
Date.displayName = 'JVR.Date';